'use client';

import React, { useId } from 'react';
import { cn } from '../lib/utils';

export interface FormSectionProps {
  title: string;
  description?: string;
  columns?: 1 | 2;
  children: React.ReactNode;
  className?: string;
}

/** Unbordered field group within the caller's single form surface. */
export function FormSection({
  title,
  description,
  columns = 2,
  children,
  className,
}: FormSectionProps) {
  const descriptionId = useId();
  return (
    <fieldset
      aria-describedby={description ? descriptionId : undefined}
      className={cn('min-w-0 space-y-4', className)}
    >
      <legend className="min-w-0 break-words font-body text-section-title text-text-heading [overflow-wrap:anywhere]">
        {title}
      </legend>
      {description && (
        <p
          id={descriptionId}
          className="min-w-0 break-words font-body text-body text-text-muted [overflow-wrap:anywhere]"
        >
          {description}
        </p>
      )}
      <div
        className={cn(
          'grid min-w-0 grid-cols-1 gap-4 [&>*]:min-w-0',
          columns === 2 && 'md:grid-cols-2',
        )}
      >
        {children}
      </div>
    </fieldset>
  );
}
